/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../../../app/bsky/actor/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'chat.bsky.actor.defs'

type $nsid = typeof $nsid

export { $nsid }

type MemberRole = 'owner' | 'standard' | l.UnknownString

export type { MemberRole }

const memberRole = /*#__PURE__*/ l.string<{
  knownValues: ['owner', 'standard']
}>()

export { memberRole }

type ProfileViewBasic = {
  $type?: 'chat.bsky.actor.defs#profileViewBasic'
  did: l.DidString
  handle: l.HandleString
  displayName?: string
  avatar?: l.UriString
  associated?: ActorDefs.ProfileAssociated
  viewer?: ActorDefs.ViewerState
  labels?: LabelDefs.Label[]
  createdAt?: l.DatetimeString

  /**
   * Set to true when the actor cannot actively participate in conversations
   */
  chatDisabled?: boolean
  verification?: ActorDefs.VerificationState

  /**
   * Union field that has data specific to different kinds of convos.
   */
  kind?:
    | l.$Typed<DirectConvoMember>
    | l.$Typed<GroupConvoMember>
    | l.$Typed<PastGroupConvoMember>
    | l.Unknown$TypedObject
}

export type { ProfileViewBasic }

const profileViewBasic = /*#__PURE__*/ l.typedObject<ProfileViewBasic>(
  $nsid,
  'profileViewBasic',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    displayName: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 64, maxLength: 640 }),
    ),
    avatar: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
    associated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileAssociated>(
        (() => ActorDefs.profileAssociated) as any,
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.ViewerState>(
        (() => ActorDefs.viewerState) as any,
      ),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    chatDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    verification: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.VerificationState>(
        (() => ActorDefs.verificationState) as any,
      ),
    ),
    kind: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<DirectConvoMember>(
            (() => directConvoMember) as any,
          ),
          /*#__PURE__*/ l.typedRef<GroupConvoMember>(
            (() => groupConvoMember) as any,
          ),
          /*#__PURE__*/ l.typedRef<PastGroupConvoMember>(
            (() => pastGroupConvoMember) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)

export { profileViewBasic }

type DirectConvoMember = { $type?: 'chat.bsky.actor.defs#directConvoMember' }

export type { DirectConvoMember }

const directConvoMember = /*#__PURE__*/ l.typedObject<DirectConvoMember>(
  $nsid,
  'directConvoMember',
  /*#__PURE__*/ l.object({}),
)

export { directConvoMember }

/** A current group convo member. */
type GroupConvoMember = {
  $type?: 'chat.bsky.actor.defs#groupConvoMember'

  /**
   * Who added this member. Only present if the member was added (instead of joining via link).
   */
  addedBy?: ProfileViewBasic

  /**
   * The member's role within this conversation. Only present in group conversation member lists.
   */
  role: MemberRole
}

export type { GroupConvoMember }

/** A current group convo member. */
const groupConvoMember = /*#__PURE__*/ l.typedObject<GroupConvoMember>(
  $nsid,
  'groupConvoMember',
  /*#__PURE__*/ l.object({
    addedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ProfileViewBasic>((() => profileViewBasic) as any),
    ),
    role: /*#__PURE__*/ l.ref<MemberRole>((() => memberRole) as any),
  }),
)

export { groupConvoMember }

/** A past group convo member. */
type PastGroupConvoMember = {
  $type?: 'chat.bsky.actor.defs#pastGroupConvoMember'
}

export type { PastGroupConvoMember }

/** A past group convo member. */
const pastGroupConvoMember = /*#__PURE__*/ l.typedObject<PastGroupConvoMember>(
  $nsid,
  'pastGroupConvoMember',
  /*#__PURE__*/ l.object({}),
)

export { pastGroupConvoMember }
